import { render, staticRenderFns } from "./logistics-verification-details.vue?vue&type=template&id=1b82b72b&"
import script from "./logistics-verification-details.vue?vue&type=script&lang=js&"
export * from "./logistics-verification-details.vue?vue&type=script&lang=js&"
import style0 from "./logistics-verification-details.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports